<app-home-header></app-home-header>

<div class="show-case">
  <div class="contenedor">
    <div class="show-info">
      <div class="show-info-left animated fadeInLeft">
        <div class="title">
          <span class="title__upper">{{ 'HOME.SHOWCASE.AUTOMATE' | translate | uppercase }}</span>
          <span class="title__lower">{{ 'HOME.SHOWCASE.All YOUR DOCUMENTS' | translate }}</span>
        </div>

        <div class="social">
          <div class="facebook">
            <a href="https://www.facebook.com/calialegal" target="_blank" rel="noopener noreferrer">
              <i class="bx bxl-facebook" aria-hidden="true"></i>
            </a>
          </div>
          <div class="instagram">
            <a href="https://www.instagram.com/calialegal/" target="_blank" rel="noopener noreferrer">
              <i class="bx bxl-instagram" aria-hidden="true"></i>
            </a>
          </div>
          <div class="twitter">
            <a href="https://twitter.com/?lang=es" target="_blank" rel="noopener noreferrer">
              <i class="bx bxl-twitter" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="show-divider"></div>
      <div class="show-info-right animated fadeInRight">
        <h2 class="subtitle">{{ 'HOME.SHOWCASE.BUILD YOUR OWN TOOL IN MINUTES' | translate }}.</h2>
        <p>{{ 'HOME.SHOWCASE.ITS TIME TO STOP WRITING AND EDITING' | translate }}.</p>
      </div>
    </div>
  </div>
</div>

<div class="sample-steps" id="pasos-crear-documento">
  <div class="contenedor">
    <h1>¡{{ 'HOME.STEPS.NO PROGRAMMING SKILLS REQUIRED' | translate }}!</h1>
    <div class="container-steps">
      <p>
        {{ 'HOME.STEPS.IF YOU KNOW HOW TO USE' | translate }}
        <strong>{{ 'HOME.MICROSOFT WORD' | translate }}</strong>
        , {{ 'HOME.STEPS.YOU WILL KNOW TO USE' | translate }}
        <strong>{{ 'HOME.AURODOC' | translate }}</strong>
        .
      </p>
      <button systemButton buttonType="primary" type="button" [routerLink]="['/register']" class="button-register">
        {{ 'HOME.SIGN UP HERE' | translate }}
      </button>
      <ul class="steps">
        <li>
          <div class="number">1</div>
          <div class="content">{{ 'HOME.STEPS.UPLOAD A DOCUMENT TO OUR EDITOR' | translate }}.</div>
        </li>
        <li>
          <div class="number">2</div>
          <div class="content content--special-number">
            {{ 'HOME.STEPS.DEFINE VARIABLES IN THE TEXT' | translate }}.
          </div>
        </li>
        <li>
          <div class="number">3</div>
          <div class="content">{{ 'HOME.STEPS.CREATE ALTERNATIVE AND CONDITIONAL TEXTS' | translate }}.</div>
        </li>
        <li>
          <div class="number">4</div>
          <div class="content content--long">
            {{
              'HOME.STEPS.THE DOCUMENT HAS BEEN AUTOMATED AND THROUGH THE GENERATE LINK YOU CAN ACCESS THE FORM'
                | translate
            }}.
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="about-us" id="quienes-somos">
  <div class="contenedor">
    <div class="image">
      <div class="content-images">
        <img src="assets/img/logotipo-calia.png" alt="Calia Tech" />
      </div>
    </div>
    <div class="info">
      <h1>{{ 'HOME.ABOUT US' | translate }}</h1>
      <p>
        <span class="feature">{{ 'HOME.AURODOC' | translate }}</span>
        {{ 'HOME.ABOUT_US.IS A PRODUCT OF' | translate }}
        <span class="feature">{{ 'HOME.CALIA' | translate }}</span>
        , {{ 'HOME.ABOUT_US.THE FIRST COMPANY OF' | translate }}
        <span class="feature">{{ 'HOME.A_R_D' | translate }}</span>
        (
        <em>{{ 'HOME.ABOUT_US.ROBOTIC DOCUMENT AUTOMATION' | translate }}</em>
        ) {{ 'HOME.ABOUT_US.OF LATINAMERICA' | translate }}.
      </p>
      <h2>¿{{ 'HOME.ABOUT_US.BUT WHAT IS AURODOC' | translate }}?</h2>
      <ul class="info__list">
        <li>{{ 'HOME.ABOUT_US.ITS IS A PROGRAMMING TOOL BASED ENTIRELY ON HUMAN LANGUAGE' | translate }}.</li>
        <li>
          {{
            'HOME.ABOUT_US.ALLOWS NON-PROGRAMMERS TO BUILD THEIR OWN STATIC OR DYNAMIC DOCUMENT AUTOMATOR' | translate
          }}.
        </li>
      </ul>
      <p>
        {{ 'HOME.ABOUT_US.WE DEVELOP THROUGH PROGRAMMING TOOLS' | translate }}
        <strong>{{ 'HOME.ABOUT_US.DO IT YOURSELF' | translate }}</strong>
        ,
        {{
          'HOME.ABOUT_US.TECHNOLOGIES THAT GENERATE EFFICIENCIES AND COST REUCTION FORM COMPANIES WITH CONSTANTS FLOWS OF DOCUMENT'
            | translate
        }}.
      </p>
    </div>
  </div>
</div>

<div class="our-challenges" id="nuestros-retos">
  <div class="contenedor">
    <h1>{{ 'HOME.OUR_CHALLENGES.TITLE' | translate }}</h1>
    <div class="container-challenges">
      <ul class="challenges">
        <li>
          <div class="percentage">60%</div>
          <div class="content">
            {{ 'HOME.OUR_CHALLENGES.REDUCTION IN' | translate }}
            <span class="feature">{{ 'HOME.OUR_CHALLENGES.COST OVERRUNS' | translate }}</span>
            {{ 'HOME.OUR_CHALLENGES.OF PROCESSES' | translate }}
            {{ 'HOME.OUR_CHALLENGES.RELATED TO DOCUMENTS' | translate }}.
          </div>
        </li>
        <li>
          <div class="percentage">70%</div>
          <div class="content">
            {{ 'HOME.OUR_CHALLENGES.REDUCTION IN' | translate }}
            <span class="feature">{{ 'HOME.OUR_CHALLENGES.TIME' | translate }}</span>
            {{ 'HOME.OUR_CHALLENGES.OF PROCESSES' | translate }},
            {{ 'HOME.OUR_CHALLENGES.IMPROVING CUSTOMER SATISFACTION' | translate }}.
          </div>
        </li>
        <li>
          <div class="percentage">80%</div>
          <div class="content">
            {{ 'HOME.OUR_CHALLENGES.REDUCTION IN' | translate }} {{ 'HOME.OUR_CHALLENGES.THE' | translate }}
            <span class="feature">{{ 'HOME.OUR_CHALLENGES.FRUSTRATION' | translate }}</span>
            {{ 'HOME.OUR_CHALLENGES.OF EMPLOYEES WICH INCREASES THE' | translate }}
            <span class="feature">{{ 'HOME.OUR_CHALLENGES.SATISFACTION' | translate }}</span>
            {{ 'HOME.OUR_CHALLENGES.AND' | translate }}
            <span class="feature">{{ 'HOME.OUR_CHALLENGES.PRODUCTIVITY' | translate }}</span>
            .
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="contact-us" id="contactanos">
  <div class="contenedor">
    <div class="form">
      <app-contact-form></app-contact-form>
    </div>
    <div class="image"></div>
  </div>
</div>

<div class="contenedor">
  <div class="divider"></div>
</div>

<app-home-footer></app-home-footer>
